import { ChangeEvent, CityState, DropdownItem, Label, RowModeControlType, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { DateUtil, DisplayType } from "@mcleod/core";
import { validatePickupWindow, validatePrepTime } from "./OrderValidation";
import { AutogenLayoutFtlStop } from "./autogen/AutogenLayoutFtlStop";
import { LtlUtil } from "./ltl/LtlUtil";

export class FtlStop extends AutogenLayoutFtlStop {

    private _disableValidation: boolean = false;
    private _hasValidPickupTimes: boolean = true;
    private textboxShipperEarly: Textbox;
    private textboxShipperLate: Textbox;


    public disableEdits() {
        this._disableValidation = true;
        this.tableStops.rowModeControlType = RowModeControlType.AUTO;
    }

    public get hasValidPickupTimes(): boolean {
        return this._hasValidPickupTimes;
    }

    public set hasValidPickupTimes(value: boolean) {
        this._hasValidPickupTimes = value;
    }

    /** This is an event handler for the onRowDisplay event of table1.  */
    tableStopsOnRowDisplay(event: TableRowDisplayEvent) {
        const row = event.getTableRow();
        const textboxEarlyPickup = row.findComponentById("textboxEarlyPickup") as Textbox;
        const textboxLatePickup = row.findComponentById("textboxLatePickup") as Textbox;
        const labelSequence = row.findComponentById("labelSequence") as Label;
        const labelStopType = row.findComponentById("labelStopType") as Label;
        const cityState = row.findComponentById("citystate") as CityState;
        labelSequence.text = (row.index + 1).toString();
        labelStopType.text = row.data.get("stop_type") == "PU" ? "Pickup" : "Delivery";
        cityState.printable = true;
        row.findComponentById("labelPickupDate").visible = true;
        this.textboxShipperEarly = textboxEarlyPickup;
        this.textboxShipperLate = textboxLatePickup;
        const earlyDate = DateUtil.parseDateTime(row.data.get("sched_arrive_early"));
        const lateDate = DateUtil.parseDateTime(row.data.get("sched_arrive_late"));
        this.textboxShipperEarly.items = LtlUtil.getPickupDateItems(earlyDate);
        this.textboxShipperLate.items = this.textboxShipperEarly.items;
        this.displayDates(this.textboxShipperEarly, "sched_arrive_early", earlyDate);
        this.displayDates(this.textboxShipperLate, "sched_arrive_late", lateDate);

        this.validatePickupTimes(null, row.index);
        this.textboxShipperEarly.addChangeListener((event: ChangeEvent) => this.textboxPickupOnChange(event, row.index));
        this.textboxShipperLate.addChangeListener((event: ChangeEvent) => this.textboxPickupOnChange(event, row.index));
    }

    private displayDates(textbox: Textbox, field: string, date: Date) {
        textbox.field = field;
        textbox.displayType = DisplayType.STRING;
        textbox.displayData(textbox.boundRow, null, 0);
        if (textbox.selectedItem == null && date != null) {
            const items = textbox.items as DropdownItem[];
            const value = DateUtil.formatDateTime(date, "HH:mm");
            items.unshift(new DropdownItem(date.toString(), value));
            textbox.selectedItem = textbox.items[0];
        }
    }

    textboxPickupOnChange(event: ChangeEvent, sequence: number = -1) {
        if (event.userInitiatedChange) {
            (event.target as Textbox).hideDropdown(true);
            this.validatePickupTimes(null, sequence);
        }
    }

    async validatePickupTimes(beforePost: boolean = false, sequence: number = -1) {
        if (this._disableValidation !== true) {
            this.hasValidPickupTimes = true;
            const shipperStop = sequence !== -1 ? this.tableStops.dataSource.data[sequence] : this.textboxShipperEarly.getRelevantModelRow();
            if (shipperStop != null) {
                this.hasValidPickupTimes = validatePickupWindow(shipperStop);
                if (shipperStop.get("stop_type") === "PU")
                    this.hasValidPickupTimes = await validatePrepTime(shipperStop) && this.hasValidPickupTimes;
            }
        }
    }
}
